var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExecution(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 97,
    height: 96,
    viewBox: "0 0 97 96",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 96.8571,
    height: 96,
    rx: 8,
    fill: "#E6E4E0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.4106 23H35.2509V28.3059H47.4106V23ZM35.2569 65.5727V65.1073H38.1625L40.4494 58.5738H47.338L49.5727 52.0408H51.6349V39.5266H42.7928V37.7696C45.4371 37.131 47.4078 34.7464 47.4078 31.9087V31.2354H35.2481V31.9087C35.2481 34.7464 37.2188 37.131 39.8631 37.7696V39.5266H29.391V41.4813H23.9287V50.1365H29.391V52.0408H32.3275L27.7533 65.1073H32.3272V65.5727C32.3272 69.6681 35.6589 72.9999 39.7544 72.9999H73.9288V70.0702H39.7544C37.2744 70.0702 35.2569 68.0526 35.2569 65.5727ZM42.7363 52.0408H46.4767L45.2437 55.6441H41.4752L42.7363 52.0408ZM68.5713 39.2602L72.645 37.9552L73.5384 40.7453L69.4651 42.0499L68.5713 39.2602ZM67.5295 39.5955L64.9912 40.4084L65.8846 43.1984L68.4233 42.3855L67.5295 39.5955ZM65.881 44.3191H68.5464V47.2488H65.881V44.3191ZM69.6475 44.3191H73.9253V47.2488H69.6475V44.3191ZM65.883 48.3663L64.9892 51.1568L67.5279 51.9697L68.4213 49.1792L65.883 48.3663ZM68.5732 52.3062L69.467 49.5161L73.5407 50.8207L72.6473 53.6108L68.5732 52.3062ZM64.4463 47.2741H60.545V52.0414H54.5586V39.5272H60.545V44.3444H64.4463V47.2741Z",
    fill: "#878787"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExecution);
export default __webpack_public_path__ + "static/media/execution.55639745bb98722b6f9c7d5d9aaa310d.svg";
export { ForwardRef as ReactComponent };